import React, { useState, useEffect } from "react";
import BasicTable from "../../Components/Table/Material";
import { usePagination } from "../../Hooks/usePagination";
import Common from "../../Components/Layouts/Common";
import { useModal } from "../../Hooks/useModal";
import Modal from "../../Components/Modal";
import IMISDataInsertionModal from "../../Components/Modal/IMISDataInsertionModal";
import useWindowWidth from "../../Hooks/useWindowWidth";
import useApi from "../../Hooks/useApi";

const DataInsertion = () => {
  const [insertionData, setInsertionData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const paginateProps = usePagination();
  const { isOpen, closeModal, openModal } = useModal();

  const windowWidth = useWindowWidth();

  const handleView = (row)  => {
    openModal();
    setSelectedRow(row);
  };

  const columns = [
    {
      id: "year",
      label: "Year",
      minWidth: 170,
    },
    {
      id: "city",
      label: "City",
      minWidth: 100,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
    },
    {
      id: "action",
      label: "Action",
      minWidth: 170,
      align: "center",
      renderCell: (row) => {
        return (
          <div className="inline-flex space-x-2">
            <button
              onClick={() => {
                handleView(row);
              }}
              className={`bg-[#1976d2] p-1.5 w-[150px] text-xs border border-gray-300  text-white rounded-md flex items-center justify-center`}
            >
              View IMIS Data
            </button>
          </div>
        );
      },
    },
  ];
  const { request } = useApi();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request(
          "GET",
          `/v1/imis/indicators?offset=${paginateProps.page}&limit=${paginateProps.rowsPerPage}`,
          {},
          "external_service"
        );
       
        
        setInsertionData(response?.content);
      } catch (error) {}
    };
    fetchData();
  }, [paginateProps.page, paginateProps.rowsPerPage]);

  return (
    <Common headline={"IMIS Data Insertion"}>
      <BasicTable
        columns={columns}
        data={insertionData}
        paginateProps={paginateProps}
      />
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        style={{ width: windowWidth >= 768 ? "70vw" : "90vw" }}
      >
        <IMISDataInsertionModal imis={selectedRow} />
      </Modal>
    </Common>
  );
};

export default DataInsertion;
